import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e8a0fecc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "warning-page"
};
const _hoisted_2 = {
  class: "warning-page__body"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<section class=\"warning-panel warning-panel--records\" data-v-e8a0fecc><header class=\"panel-head\" data-v-e8a0fecc><div data-v-e8a0fecc><p class=\"panel-eyebrow\" data-v-e8a0fecc>CURRENT ALERTS</p><h2 class=\"panel-title\" data-v-e8a0fecc>当前告警记录</h2></div><span class=\"panel-badge\" data-v-e8a0fecc>0 条</span></header><div class=\"record-empty\" data-v-e8a0fecc><div class=\"record-empty__icon\" data-v-e8a0fecc></div><strong class=\"record-empty__title\" data-v-e8a0fecc>暂无告警记录</strong><p class=\"record-empty__desc\" data-v-e8a0fecc>本时段所有系统运行正常，未出现待处理或已处理告警。</p></div></section>", 1);
const _hoisted_4 = {
  class: "warning-page__side"
};
const _hoisted_5 = {
  class: "warning-panel"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "panel-head"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", {
  class: "panel-eyebrow"
}, "SUMMARY"), /*#__PURE__*/_createElementVNode("h2", {
  class: "panel-title"
}, "告警概览")])], -1));
const _hoisted_7 = {
  class: "summary-grid"
};
const _hoisted_8 = {
  class: "summary-card__label"
};
const _hoisted_9 = {
  class: "summary-card__value"
};
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<section class=\"warning-panel\" data-v-e8a0fecc><header class=\"panel-head\" data-v-e8a0fecc><div data-v-e8a0fecc><p class=\"panel-eyebrow\" data-v-e8a0fecc>RANKING</p><h2 class=\"panel-title\" data-v-e8a0fecc>近 24 小时告警排名</h2></div></header><div class=\"ranking-empty\" data-v-e8a0fecc><span class=\"ranking-empty__text\" data-v-e8a0fecc>暂无告警设备</span></div></section>", 1);
const _hoisted_11 = {
  class: "warning-panel warning-panel--trend"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "panel-head"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", {
  class: "panel-eyebrow"
}, "TREND"), /*#__PURE__*/_createElementVNode("h2", {
  class: "panel-title"
}, "24 小时告警趋势")])], -1));
const _hoisted_13 = {
  class: "trend-chart"
};
const _hoisted_14 = {
  class: "trend-item__bar"
};
const _hoisted_15 = {
  class: "trend-item__label"
};
const _hoisted_16 = {
  class: "trend-item__value"
};
import Head from "@/components/Head/index.vue";
import FootBar from "@/components/FootBar/index.vue";
export default {
  __name: 'index',
  setup(__props) {
    const summaryCards = [{
      label: "当前活动告警",
      value: "0"
    }, {
      label: "今日新增告警",
      value: "0"
    }, {
      label: "已处理告警",
      value: "0"
    }, {
      label: "系统健康状态",
      value: "正常"
    }];
    const trendData = [{
      label: "00:00",
      value: 0,
      height: 6
    }, {
      label: "04:00",
      value: 0,
      height: 6
    }, {
      label: "08:00",
      value: 0,
      height: 6
    }, {
      label: "12:00",
      value: 0,
      height: 6
    }, {
      label: "16:00",
      value: 0,
      height: 6
    }, {
      label: "20:00",
      value: 0,
      height: 6
    }];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Head, {
        title: "报警信息"
      }), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("section", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(summaryCards, item => {
        return _createElementVNode("article", {
          key: item.label,
          class: "summary-card"
        }, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1), _createElementVNode("strong", _hoisted_9, _toDisplayString(item.value), 1)]);
      }), 64))])]), _hoisted_10])]), _createElementVNode("section", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(trendData, item => {
        return _createElementVNode("article", {
          key: item.label,
          class: "trend-item"
        }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
          class: "trend-item__fill",
          style: _normalizeStyle({
            height: `${item.height}%`
          })
        }, null, 4)]), _createElementVNode("span", _hoisted_15, _toDisplayString(item.label), 1), _createElementVNode("span", _hoisted_16, _toDisplayString(item.value), 1)]);
      }), 64))])]), _createVNode(FootBar)]);
    };
  }
};